export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/spoof-bold-526bdddde77c61b1b3094c91e57a1716.woff";